import { render, staticRenderFns } from "./DateTimeColumn.vue?vue&type=template&id=6e70a4f8&"
import script from "./DateTimeColumn.vue?vue&type=script&lang=js&"
export * from "./DateTimeColumn.vue?vue&type=script&lang=js&"
import style0 from "./DateTimeColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e70a4f8')) {
      api.createRecord('6e70a4f8', component.options)
    } else {
      api.reload('6e70a4f8', component.options)
    }
    module.hot.accept("./DateTimeColumn.vue?vue&type=template&id=6e70a4f8&", function () {
      api.rerender('6e70a4f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/DateTimeColumn.vue"
export default component.exports